import React, { useEffect, useState, useContext } from 'react';
import SglContext from '../SglContext';
import axios from 'axios';
import './termsOfService.css'; 
function TermsOfService() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [agreement, setAgreement] = useState(null);
  const Sgl = useContext(SglContext);

  useEffect(() => {
    fetchTermsOfService();
  }, []);

  const fetchTermsOfService = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${Sgl.nestApiUrl}/billing/public-terms-of-service`,
        {
          params: {
            company_id: Sgl.company_id
          }
        }
      );

      if (response.data.success) {
        setAgreement(response.data.agreement);
      } else {
        setError(response.data.error || 'Failed to load Terms of Service');
      }
    } catch (err) {
      console.error('Error fetching Terms of Service:', err);
      setError('Unable to load Terms of Service. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="tos-container">
        <div className="tos-loading">Loading Terms of Service...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tos-container">
        <div className="tos-error">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!agreement) {
    return (
      <div className="tos-container">
        <div className="tos-error">
          <p>Terms of Service not available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tos-container">
      <div className="tos-content">
        <div 
          dangerouslySetInnerHTML={{ __html: agreement.content }}
        />
      </div>
    </div>
  );
}

export default TermsOfService;